<div class="cbic-loader" *ngIf="isLoading">
    <mat-progress-spinner class="spinner" mode="indeterminate" [color]="'red'">
    </mat-progress-spinner>
</div>